import React, { memo } from 'react';
import iconBundle from '@features/pdp/images/icons/icon-bundle.svg';
import cx from '@utils/cx.util';
// const DEFAULT_BACKGROUND_COLOR = '#447442';
// const DEFAULT_FOREGROUND_COLOR = '#ffffff';

export const ProductBundleBar = ({ bundleInfo, showIcon = true, className }) => {
  if (!bundleInfo) return null;

  const subheader = bundleInfo.bundle.subheader?.replaceAll(
    '{freeItemsValue}',
    bundleInfo.bundlePricing.freeItemsValue
  );
  // const subheaderBackgroundColor = bundleInfo.bundle.subheaderBg ?? DEFAULT_BACKGROUND_COLOR;
  // const subheaderForegroundColor = bundleInfo.bundle.subheaderFg ?? DEFAULT_FOREGROUND_COLOR;
  const expires = !!bundleInfo.bundle.expirationTimestampFormatted;
  const body = expires ? subheader : `${subheader}`;

  return (
    <div className={cx('tw:mb-3 tw:flex tw:items-start tw:gap-3', className)}>
      {showIcon && (
        <div className='tw:w-7 tw:shrink-0 tw:grow-0'>
          <img src={iconBundle} alt='Bundle Icon' className='tw:h-full tw:w-full tw:min-w-7' />
        </div>
      )}

      <div className='tw:text-base tw:font-bold tw:leading-tight tw:text-body tw:[&_span]:block tw:[&_span]:text-base tw:[&_span]:font-medium'>
        <div className=''>{subheader && <div dangerouslySetInnerHTML={{ __html: body }} />}</div>
      </div>
    </div>
  );
};

export default memo(ProductBundleBar);
